import { ref, watch, computed, getCurrentInstance } from 'vue';
import { AlarmWebsocket } from '@blade/common/utils/websocket';
import { useMonitoringStore } from '@blade-sxp/monitoring-center/store/index';
import { getSnapImageList } from '@blade-sxp/monitoring-center/api/index';
import { SNAP_COLLAPSE_NUM, SNAP_OPEN_NUM } from '@blade-sxp/monitoring-center/utils/const';
import moment from 'moment';
const store = useMonitoringStore();
export const useSnapImage = () => {
    const vm = getCurrentInstance();
    const router = vm?.proxy?.$router;
    const isCollapse = ref(true); // 是否折叠
    let canUpdates = true; // 数据是否可以持续更新
    const imgList = ref([]);
    const wsDataArr = [];
    let ws = undefined;
    const wsInitFns = [];
    let timer = 0;
    const wsUrl = process.env.NODE_ENV === 'development'
        ? process.env.VUE_APP_REALTIME_WS
        : `wss://${window.location.host}/${process.env.VUE_APP_REALTIME_WS}`;
    const showMaxNum = computed(() => isCollapse.value ? SNAP_COLLAPSE_NUM : SNAP_OPEN_NUM);
    const timeData = {
        startTime: '',
        endTime: ''
    };
    watch(() => store.selectedDevices, () => {
        const deviceIds = store.selectedDevices;
        onWebsocketMessage(deviceIds);
        if (!deviceIds.length) {
            imgList.value = [];
            return;
        }
        fetchImageList(deviceIds);
    });
    const showImgList = computed(() => imgList.value.slice(0, showMaxNum.value));
    const fetchImageList = (deviceIds) => {
        timeData.startTime = moment().add(-7, 'd').format('yyyy-MM-DD HH:mm:ss');
        timeData.endTime = moment().format('yyyy-MM-DD HH:mm:ss');
        const param = {
            deviceIds,
            endTime: timeData.endTime,
            page: 0,
            size: showMaxNum.value,
            startTime: timeData.startTime,
        };
        getSnapImageList(param).then((res) => {
            if (!res?.list?.length)
                return;
            imgList.value = res.list;
        });
    };
    // 折叠展开列表事件    
    const toggleCollapse = () => {
        isCollapse.value = !isCollapse.value;
    };
    const unfold = () => {
        isCollapse.value = false;
    };
    // 初始化websocket
    const initWebSocket = () => {
        ws = new AlarmWebsocket(wsUrl);
        while (wsInitFns.length) {
            const fn = wsInitFns.shift();
            fn();
        }
        ws.setOnMessage(websocketonmessage);
    };
    const websocketonmessage = (e) => {
        if (!/{.*}/g.test(e.data))
            return;
        const data = e.data && JSON.parse(e.data);
        if (!data || data.messageType !== 'SNAP_IMAGE_REALTIME')
            return;
        const { content } = data;
        wsOnMessage(content);
    };
    const wsOnMessage = (content) => {
        if (!canUpdates)
            return;
        if (imgList.value?.find((e) => e.objectId !== content.objectId && String(e.deviceId) === String(content.deviceId))) {
            wsDataArr.unshift(content);
            timer && clearTimeout(timer);
            timer = window.setTimeout(() => {
                updateData();
            }, 1000);
        }
    };
    const updateData = () => {
        imgList.value = [...wsDataArr, ...imgList.value];
    };
    const onWebsocketMessage = (deviceIds) => {
        if (deviceIds.length) {
            websocketSendMessage(deviceIds);
        }
        else {
            websocketCloseMessage(deviceIds);
        }
    };
    const websocketSendMessage = (deviceIds) => {
        const params = JSON.stringify(getWsMessageParam(deviceIds, 'SUBSCRIBE'));
        if (ws) {
            ws?.ws?.send(params);
        }
        else {
            wsInitFns.push(() => {
                ws.ws.onopen = () => {
                    ws.ws.send(params);
                };
            });
        }
    };
    const websocketCloseMessage = (deviceIds) => {
        ws?.ws?.send(JSON.stringify(getWsMessageParam(deviceIds, 'UNSUBSCRIBE')));
    };
    const getWsMessageParam = (ids, requestType) => {
        return {
            requestId: '7NREgwyBCDEGJya1YwKoT8siOPR',
            requestType: requestType,
            subscribeModel: 'DEFAULT',
            subscribeScript: {
                messageSubscribeScript: ids.map((id) => `#{#deviceId}=='${id}'`).join(' or '),
                subscribeMessageType: [],
            },
        };
    };
    const closeWebSocket = () => {
        ws?.close();
    };
    const mouseenter = () => {
        canUpdates = false;
    };
    const mouseleave = () => {
        canUpdates = true;
    };
    const handleClick = (portraitImage) => {
        const { startTime, endTime } = timeData;
        const deviceIds = store.selectedDevices;
        router && window.open(`${router.resolve({
            path: '/monitoringCenter/snapRecord', query: {
                params: JSON.stringify({ deviceId: deviceIds, startTime, endTime, image: portraitImage })
            }
        }).href}`);
    };
    return { toggleCollapse, unfold, initWebSocket, closeWebSocket, mouseenter, mouseleave, handleClick, isCollapse, showImgList, timeData };
};
